import Promise from 'es6-promise';
import ApiMagento from '../api/magento';
import Config from '../config/index';
import Lang from '../lang';
import Log from '../log';
import Spinner from "../spinner";

let data = {
    promises: [],
    promise: null,
    isDataFetched: false,
    categories: null,
    products: null,
    productsByCategory: null,
    iconMappings: {
        28: 'earth',
        29: 'layers',
        30: 'bold',
        default: 'drop'
    }
};


// and transform it once it's fetched
data.promise = new Promise((resolve, reject) => {
    // show loading spinner
    Spinner.show();

    // fetch data from server
    Lang.promise.then(() => {
        data.promises.push(ApiMagento.query('categories').then((res) => data.categories = res));
        data.promises.push(ApiMagento.query('products').then((res) => data.products = res));

        // work with data
        Promise.all(data.promises).then(() => {
            data.categoryKeysOrdered = getCategoryKeysOrdered();
            data.productsByCategory = getProductsByCategory();
            data.isDataFetched = true;

            Log.trace('DATA', data);
            Log.trace('CONFIG', Config);

            resolve(data);

        }).catch(reject);
    }).catch(reject);
});

function getCategoryKeysOrdered() {
    return Object.keys(data.categories)
        .map((id) => {
            let cat = data.categories[id];
            return {
                id: cat.id,
                position: cat.position
            }
        })
        .sort((a, b) => a.position - b.position)
        .map((p) => p.id);
}

function getProductsByCategory() {
    let productsByCategory = {};

    data.products.forEach((prod) => {
        let cat = prod.category[prod.category.length - 1];
        if (!productsByCategory[cat]) productsByCategory[cat] = [];

        productsByCategory[cat].push(prod);
    });
    return productsByCategory;
}

export default data;
